/* Mobile-only product accordions. Preserve the existing Shopify product and Judge.me nodes. */
(function () {
  'use strict';

  var media = window.matchMedia('(max-width: 768px)');
  var detailsSection = null;
  var reviewSection = null;
  var reviewOriginalPosition = null;
  var reviewButton = null;
  var ratingUpdateQueued = false;
  var layoutUpdateQueued = false;

  function setupDetailButtons(section) {
    section.querySelectorAll('[data-rc-mobile-accordion-toggle]').forEach(function (button) {
      if (button.dataset.rcAccordionBound === '1') return;
      button.dataset.rcAccordionBound = '1';
      button.addEventListener('click', function () {
        var panel = button.parentElement;
        var expanded = panel.classList.toggle('rc-mobile-open');
        button.setAttribute('aria-expanded', String(expanded));
      });
    });
  }

  function getReviewSection() {
    // The review app is an independent section in the supplied product.json.
    var exact = document.querySelector('[id$="__16802429123704a4c4"]');
    if (exact && exact.classList.contains('shopify-section')) return exact;
    var widget = document.querySelector('#judgeme_product_reviews');
    return widget ? widget.closest('.shopify-section') : null;
  }

  function makeReviewButton(section) {
    var button = section.querySelector(':scope > .rc-mobile-review-toggle');
    if (!button) {
      // Both SVG layers have identical geometry; the filled one is clipped to
      // the actual numeric product rating, including fractional stars.
      var stars = '';
      var points = '10,1.1 12.8,6.7 19,7.5 14.5,11.8 15.7,18 10,14.9 4.3,18 5.5,11.8 1,7.5 7.2,6.7';
      for (var i = 0; i < 5; i++) {
        stars += '<polygon points="' + points + '" transform="translate(' + (i * 20) + ',0)"/>';
      }
      var emptyStars = '<svg viewBox="0 0 100 20" aria-hidden="true" preserveAspectRatio="none" class="rc-mobile-review-star-svg rc-mobile-review-star-svg--outline">' + stars + '</svg>';
      var filledStars = '<svg viewBox="0 0 100 20" aria-hidden="true" preserveAspectRatio="none" class="rc-mobile-review-star-svg rc-mobile-review-star-svg--filled">' + stars + '</svg>';
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'rc-mobile-review-toggle';
      var label = (detailsSection && detailsSection.querySelector('[data-redcamp-details-section]') &&
        detailsSection.querySelector('[data-redcamp-details-section]').getAttribute('data-rc-mobile-reviews-label')) || 'Reviews';
      var labelNode = document.createElement('span');
      labelNode.textContent = label;
      button.innerHTML = '<span class="rc-mobile-review-toggle__heading">' +
        '<span class="rc-mobile-review-label"></span>' +
        '<span class="rc-mobile-review-stars" aria-hidden="true" hidden>' +
          emptyStars + '<span class="rc-mobile-review-stars__fill">' + filledStars + '</span></span>' +
        '<span class="rc-mobile-review-count" hidden></span></span>' +
        '<span class="redcamp-mobile-accordion__chevron" aria-hidden="true"></span>';
      section.insertBefore(button, section.firstChild);
      button.querySelector('.rc-mobile-review-label').textContent = labelNode.textContent;
    }
    var config = detailsSection && detailsSection.querySelector('[data-redcamp-details-section]');
    var configuredLabel = config && config.getAttribute('data-rc-mobile-reviews-label');
    var reviewLabel = button.querySelector('.rc-mobile-review-label');
    if (reviewLabel && configuredLabel !== null && reviewLabel.textContent !== configuredLabel) {
      reviewLabel.textContent = configuredLabel;
    }
    if (!button.dataset.rcAccordionBound) {
      button.dataset.rcAccordionBound = '1';
      button.addEventListener('click', function () {
        var expanded = section.classList.toggle('is-rc-mobile-open');
        button.setAttribute('aria-expanded', String(expanded));
        if (expanded) scheduleRatingUpdate();
      });
    }
    button.setAttribute('aria-expanded', String(section.classList.contains('is-rc-mobile-open')));
    var content = Array.from(section.children).find(function (child) {
      return child !== button && child.nodeType === 1;
    });
    if (content) {
      if (!content.id) content.id = section.id + '-rc-reviews-content';
      button.setAttribute('aria-controls', content.id);
    }
    return button;
  }

  function numerical(value) {
    if (value === null || value === undefined || String(value).trim() === '') return null;
    var n = Number(String(value).replace(/,/g, '').trim());
    return Number.isFinite(n) ? n : null;
  }

  function readRating() {
    var result = { score: null, count: null };
    // Judge.me's product preview badge supplies product-specific numeric values.
    var badge = document.querySelector('.redcamp-default-pdp .jdgm-prev-badge[data-number-of-reviews], ' +
      '.redcamp-default-pdp .jdgm-preview-badge [data-number-of-reviews], ' +
      '.redcamp-default-pdp [data-average-rating][data-number-of-reviews]');
    if (badge) {
      result.score = numerical(badge.getAttribute('data-average-rating'));
      result.count = numerical(badge.getAttribute('data-number-of-reviews'));
    }
    // Judge.me review widgets can load after the page's preview badge.
    var widget = document.querySelector('#judgeme_product_reviews');
    var widgetHeader = widget && widget.querySelector('.jm-review-widget-header');
    if (widgetHeader && (result.count === null || result.count === 0 || result.score === null)) {
      var countNode = widgetHeader.querySelector('.rc-jm-review-count, .jm-review-count');
      var countText = countNode ? countNode.textContent : widgetHeader.textContent;
      var countMatch = countText.match(/([\d,]+)\s+reviews?\b/i);
      var widgetCount = countMatch ? numerical(countMatch[1]) : null;
      var scoreNode = widgetHeader.querySelector('.rc-jm-score-number');
      var widgetScore = scoreNode ? numerical(scoreNode.textContent) : null;
      if (widgetCount !== null && (result.count === null || widgetCount > result.count)) {
        result.count = widgetCount;
        if (widgetScore !== null) result.score = widgetScore;
      }
      if (result.score === null && widgetScore !== null) result.score = widgetScore;
    }
    // Shopify's standard review metafields are an additional source.
    if (detailsSection) {
      if (result.score === null) result.score = numerical(detailsSection.dataset.rcReviewRating);
      if (result.count === null) result.count = numerical(detailsSection.dataset.rcReviewCount);
    }
    return result;
  }

  function updateRating() {
    if (!reviewButton || !reviewButton.isConnected) return;
    var data = readRating();
    var count = reviewButton.querySelector('.rc-mobile-review-count');
    var stars = reviewButton.querySelector('.rc-mobile-review-stars');
    if (data.count !== null && data.count >= 0) {
      var label = '(' + Math.floor(data.count).toLocaleString('en-US') + ')';
      if (count.textContent !== label) count.textContent = label;
      count.hidden = false;
    } else {
      count.hidden = true;
    }
    if (data.score !== null && data.score >= 0 && data.score <= 5 && data.count !== 0) {
      var pct = (Math.round(data.score * 200) / 10) + '%';
      if (stars.style.getPropertyValue('--rc-mobile-rating-fill') !== pct) {
        stars.style.setProperty('--rc-mobile-rating-fill', pct);
      }
      stars.hidden = false;
      var ratingText = data.score.toFixed(1) + ' out of 5 stars';
      var accessibleLabel = (reviewButton.querySelector('.rc-mobile-review-label')?.textContent || 'Reviews') + ', ' + ratingText +
        (data.count !== null ? ', ' + Math.floor(data.count) + ' reviews' : '');
      if (reviewButton.getAttribute('aria-label') !== accessibleLabel) {
        reviewButton.setAttribute('aria-label', accessibleLabel);
      }
    } else {
      stars.hidden = true;
      reviewButton.removeAttribute('aria-label');
    }
  }

  function scheduleRatingUpdate() {
    if (ratingUpdateQueued) return;
    ratingUpdateQueued = true;
    requestAnimationFrame(function () {
      ratingUpdateQueued = false;
      updateRating();
    });
  }

  function applyLayout() {
    detailsSection = document.querySelector('.redcamp-product-details-section');
    if (!detailsSection) return;
    setupDetailButtons(detailsSection);

    if (reviewSection && !reviewSection.isConnected) {
      reviewSection = null;
      reviewButton = null;
      reviewOriginalPosition = null;
    }
    if (!reviewSection) reviewSection = getReviewSection();
    if (!reviewSection) return;

    if (media.matches) {
      if (!reviewOriginalPosition || !reviewOriginalPosition.isConnected) {
        reviewOriginalPosition = document.createElement('span');
        reviewOriginalPosition.hidden = true;
        reviewOriginalPosition.className = 'rc-mobile-review-original-position';
        reviewSection.parentNode.insertBefore(reviewOriginalPosition, reviewSection);
      }
      if (reviewSection.previousElementSibling !== detailsSection) {
        detailsSection.insertAdjacentElement('afterend', reviewSection);
      }
      reviewSection.classList.add('rc-mobile-review-section');
      reviewButton = makeReviewButton(reviewSection);
      scheduleRatingUpdate();
    } else {
      if (reviewOriginalPosition && reviewOriginalPosition.parentNode) {
        reviewOriginalPosition.parentNode.insertBefore(reviewSection, reviewOriginalPosition);
        reviewOriginalPosition.remove();
      }
      reviewOriginalPosition = null;
      reviewSection.classList.remove('rc-mobile-review-section', 'is-rc-mobile-open');
      if (reviewButton) reviewButton.setAttribute('aria-expanded', 'false');
    }
  }

  function scheduleLayout() {
    if (layoutUpdateQueued) return;
    layoutUpdateQueued = true;
    requestAnimationFrame(function () {
      layoutUpdateQueued = false;
      applyLayout();
    });
  }

  function init() {
    scheduleLayout();
    // Load order can vary because the native Judge.me block is injected asynchronously.
    var observer = new MutationObserver(function (changes) {
      var found = changes.some(function (change) {
        if (change.type === 'attributes') return true;
        return Array.from(change.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;
          return (node.matches && node.matches('.jdgm-prev-badge, .jm-review-widget-header, #judgeme_product_reviews, .redcamp-product-details-section, [id$="__16802429123704a4c4"]')) ||
            (node.querySelector && node.querySelector('.jdgm-prev-badge, .jm-review-widget-header, #judgeme_product_reviews'));
        });
      });
      if (found) {
        if (!reviewSection || !reviewSection.isConnected) scheduleLayout();
        scheduleRatingUpdate();
      }
    });
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-average-rating', 'data-number-of-reviews']
    });
    if (media.addEventListener) media.addEventListener('change', scheduleLayout);
    else if (media.addListener) media.addListener(scheduleLayout);
    document.addEventListener('shopify:section:load', scheduleLayout);
    document.addEventListener('shopify:section:unload', scheduleLayout);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
